// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37a2j","badges":"styles_badges__3wcZU"};